module.exports = __webpack_public_path__ + "img/h3.0e110112.png";